import { Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { GLOBAL_MARKETER_CONFIG } from './base/global-marketer-config';

export const globalMarketerRoutes: Routes = [
  {
    path: GLOBAL_MARKETER_CONFIG.routePath, // 'master/global-marketer'
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/global-marketer-list-page/global-marketer-list-page.component'
          ).then((m) => m.GlobalMarketerListPageComponent),
        canActivate: [
          permissionGuard(...(GLOBAL_MARKETER_CONFIG.permissions ?? [])),
        ],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/global-marketer-detail-page/global-marketer-detail-page.component'
              ).then((m) => m.GlobalMarketerDetailPageComponent),
          },
        ],
      },
    ],
  },
];
